import React from "react";
import { Input, Row } from "reactstrap";
import { ColPrompt } from "./index";
import { ColValue, ErrorDiv } from "../ProductionModule/index";
import { useMachineSetupContextUpdater } from "./useMachineSetupContextUpdater";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
// Used on DP5, Duro, and Xeno machines

export default function SpeedStartToEndRow({
   valueProp1 = "speedStart",
   valueProp2 = "speedMiddle",
   valueProp3 = "speedEnd",
   diffDisplayProp1 = "Start:",
   diffDisplayProp2 = "Middle:",
   diffDisplayProp3 = "End:",
}) {
   const { handleInputRangeChange } = useMachineSetupContextUpdater();
   const { machineSetup, errorDivDefinitions } = useMachineSetupContextState();
   const defaultOnChangeVal = { target: { value: "" } };

   return (
      <Row className="mb-2">
         <ColPrompt title={"Speed"} bold={true} description={"yds/min"} />
         <ColValue size={2}>
            {diffDisplayProp1}
            <Input
               type="text"
               style={{ borderRadius: "10px", fontSize: "14px" }}
               value={machineSetup.extendedPropertyJson?.[valueProp1] || ""}
               onChange={(e) =>
                  e.target.value
                     ? handleInputRangeChange(e, 50, 9999, valueProp1)
                     : handleInputRangeChange(defaultOnChangeVal, 50, 9999, valueProp1)
               }
            />
            {errorDivDefinitions?.[valueProp1] && (
               <ErrorDiv>{"50-9,999 only"}</ErrorDiv>
            )}
         </ColValue>
         <ColValue size={2}>
            {diffDisplayProp2}
            <Input
               type="text"
               style={{ borderRadius: "10px", fontSize: "14px" }}
               value={machineSetup.extendedPropertyJson?.[valueProp2] || ""}
               onChange={(e) =>
                  e.target.value
                     ? handleInputRangeChange(e, 50, 9999, valueProp2)
                     : handleInputRangeChange(defaultOnChangeVal, 50, 9999, valueProp2)
               }
            />
            {errorDivDefinitions?.[valueProp2] && (
               <ErrorDiv>{"50-9,999 only"}</ErrorDiv>
            )}
         </ColValue>
         <ColValue size={2}>
            {diffDisplayProp3}
            <Input
               type="text"
               style={{ borderRadius: "10px", fontSize: "14px" }}
               value={machineSetup.extendedPropertyJson?.[valueProp3] || ""}
               onChange={(e) =>
                  e.target.value
                     ? handleInputRangeChange(e, 50, 9999, valueProp3)
                     : handleInputRangeChange(defaultOnChangeVal, 50, 9999, valueProp3)
               }
            />
            {errorDivDefinitions?.[valueProp3] && (
               <ErrorDiv>{"50-9,999 only"}</ErrorDiv>
            )}
         </ColValue>
      </Row>
   );
}
